<script setup lang="ts">
  import { useUserStore } from '@bv/stores/user';
  import { trans } from '@bv/utils/i18n';
  import { computed, ref, watch } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { walletApi } from '@/api/wallet';
  import { canAccessNewBillingFeatures } from '@/utils/workspace-info';

  import RechargeWalletForm from './RechargeWalletForm.vue';

  const { locale } = useI18n();

  const userStore = useUserStore();

  const balance = ref<number | undefined>(undefined);
  const invalidBalance = ref<boolean>(true);

  const currentWorkspace = computed(() => userStore.currentWorkspace);

  const getWalletBalance = () => {
    balance.value = undefined;

    walletApi.show().then((response) => {
      if (!response.balance && response.invalid_balance) {
        invalidBalance.value = true;
        return;
      }
      balance.value = response.balance;
      invalidBalance.value = false;
    });
  };

  watch(
    () => currentWorkspace.value?.id,
    () => {
      if (canAccessNewBillingFeatures.value) {
        getWalletBalance();
      }
    },
    { immediate: true },
  );

  const modalState = ref(false);
</script>

<template>
  <template v-if="canAccessNewBillingFeatures">
    <div
      class="gap-2 px-3"
      :class="$attrs.class"
    >
      <bv-btn
        class="h-10 w-10 p-0"
        :disabled="invalidBalance"
        variant="secondary"
        @click="modalState = true"
      >
        <bv-icon
          icon="bvi-add"
          size="lg"
        />
      </bv-btn>

      <div class="min-w-20 cursor-default">
        <h4 class="text-xs text-gray-500">
          {{ trans('wallet.title') }}
        </h4>

        <p
          class="flex items-center gap-1 text-sm font-bold"
          :class="invalidBalance ? 'text-gray-100' : 'text-gray-700'"
        >
          <bv-icon icon="bvi-currency-riyal" />

          <span class="text-sm leading-5">
            {{ balance !== undefined ? Number(balance).toLocaleString(locale + '-SA') : '----' }}
          </span>
        </p>
      </div>

      <bv-icon
        icon="bvi-wallet"
        size="lg"
      />
    </div>

    <bv-modal
      v-model="modalState"
      confirm-text="Recharge"
      title="Recharge your wallet"
    >
      <recharge-wallet-form />
    </bv-modal>
  </template>
</template>
